
import { MdMenu } from "react-icons/md";
import { FaBagShopping } from "react-icons/fa6";
import { useEffect, useRef, useState } from "react";
import MenuCards from "../../components/menu-cards/MenuCards";
import { closestCorners, DndContext, DragEndEvent, KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core"
import { CiMobile1, CiLaptop } from "react-icons/ci";
import { IoCart } from "react-icons/io5";
import { FaSnapchat } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { PiTiktokLogo } from "react-icons/pi";
import { LuFacebook } from "react-icons/lu";
import { FaInstagram } from "react-icons/fa6";
import { LuLinkedin } from "react-icons/lu";
import { FaWhatsapp } from "react-icons/fa6";
import { LuPhone } from "react-icons/lu";
import { useDispatch } from 'react-redux';
import { selectColor, setColor } from '../../store/theme.color.slice';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useSelector } from "react-redux";
import axios from "axios";
import { FaChevronDown } from "react-icons/fa";
import { CiImageOn } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import { FaGear } from "react-icons/fa6";
import toast from "react-hot-toast";
import { Skeleton } from "@/components/ui/skeleton";
import { Product } from "@/types/ProductType";
import Category from "@/components/menu-cards/Category";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { useTranslation } from "react-i18next";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";


interface Category {
  categoryID: string;
  nameAR: string;
  nameEN: string;
  products: Product[];
}

interface ApiResponse {
  success: boolean;
  logo: string;
  cover: string;
  primaryColor: string;
  categories: Category[];
}

function Theme() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const dispatch = useDispatch();
  const [themeData, setThemeData] = useState<ApiResponse>()
  const [categories, setCategories] = useState<Category[]>()
  const navRef = useRef<HTMLDivElement>(null);
  const layerRef = useRef<HTMLDivElement>(null);
  const settingsRef = useRef<HTMLDivElement>(null);
  const cartRef1 = useRef<HTMLDivElement>(null);
  const cartRef2 = useRef<HTMLDivElement>(null);
  const coverRef = useRef<HTMLInputElement>(null);
  const colorInputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const cardContainerRef = useRef<HTMLDivElement>(null);
  const [coverPic, setCoverPic] = useState<string | null>(null);
  const [coverPicFile, setCoverPicFile] = useState<File | string>("");
  const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
  const baseUrl = import.meta.env.VITE_BASE_URL
  const [settingsOpen, setSettingsOpen] = useState(false);
  const getCategoryPos = (id: string) => categories?.findIndex((category: Category) => category.categoryID === id);
  const color = useSelector(selectColor);
  const [activeButton, setActiveButton] = useState('desktop');
  const [loading, setLoading] = useState(false)
  const cropperRef = useRef<ReactCropperElement>(null);
  const [croppedPic, setCroppedPic] = useState<string | null>(null);
  const [croppedPicFile, setCroppedPicFile] = useState<File | string>("");
  const [beforeCrop, setBeforeCrop] = useState<string | null>(null)
  const [cropedOpen, setCropedOpen] = useState(false)
  const [buttonView, setButtonView] = useState(false)
  useLockBodyScroll(cropedOpen);
  const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB
  const MAX_IMAGE_SIZE_MB_String = {
    en: `${MAX_IMAGE_SIZE / 1024 / 1024}MB`,
    ar: `${MAX_IMAGE_SIZE / 1024 / 1024} ميجابايت`,
  }; // STRING

  function toggleCropedOpen() {
    setCropedOpen(!cropedOpen)
  }


  async function submitTheme() {
    setButtonView(false)
    const toastID = toast.loading(t("themes.updating") as string);
    try {


      const formData = new FormData();
      formData.append('primaryColor', color);
      if (coverPicFile) {
        formData.append('cover', croppedPicFile);
      } else {
        formData.append('cover', "");
      }



      formData.append('sort', JSON.stringify(categories?.map((e: Category) => e.categoryID)));

      const options = {
        url: `${baseUrl}/api/dashboard/theme?locale=en`,
        method: "PUT",
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      };



      const response = await axios.request(options);
      if (response.data.success == true) {
        toast.success(t("themes.updateSuccess") as string)
        getTheme()
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      toast.dismiss(toastID)
    }
  }


  async function getTheme() {
    setLoading(true)
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/theme?locale=en`,
        method: "GET",
        headers: {
          Authorization: token,
        }
      }

      const response = await axios.request(options)
      const primaryColor = response.data.primaryColor
      if (navRef.current && primaryColor) {
        navRef.current.style.backgroundColor = primaryColor
      }
      if (navRef.current && primaryColor === null) {
        navRef.current.style.backgroundColor = "rgb(255 255 255)";
      }

      setCoverPic(response.data.cover)
      if (primaryColor !== null) {
        dispatch(setColor(response.data.primaryColor))
      }
      setThemeData(response.data)
      setCategories(response.data.categories)
      if (response.data.cover) {
        setCoverPic(response.data.cover)
        setCoverPicFile(response.data.cover)
        setBeforeCrop(response.data.cover)
        setCroppedPicFile(response.data.cover)
      }
    } catch (error) {
      console.error(error);

    }
    setLoading(false)
  }


  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setCategories((prevCategories = []) => {
      // Get the original and new positions
      const originalPos = getCategoryPos(String(active.id)) ?? -1; // Use fallback value of -1 if undefined
      const newPos = getCategoryPos(String(over.id)) ?? -1; // Same for newPos

      // Check if positions are valid
      if (originalPos === -1 || newPos === -1) return prevCategories; // Prevent errors

      return arrayMove(prevCategories, originalPos, newPos);
    });
  };
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  )





  function openSettings() {
    if (!settingsOpen) {
      if (settingsRef.current) {


        settingsRef.current.classList.remove("-end-[500px]");
        settingsRef.current.classList.add("end-0");
        layerRef.current?.classList.remove("hidden");
        setSettingsOpen(true)



      }
    }
  }
  function closeSettings() {
    if (settingsOpen) {
      if (settingsRef.current) {
        settingsRef.current.classList.remove("end-0");
        settingsRef.current.classList.add("-end-[500px]");
        layerRef.current?.classList.add("hidden");
        setSettingsOpen(false)


      }
    }
  }
  useEffect(() => {
    function handleResize() {
      // Use Tailwind's xl breakpoint (1280px) via CSS media query
      const isXl = window.matchMedia('(min-width: 1280px)').matches;

      if (isXl) {
        closeSettings(); // Close settings if the screen is xl or larger
      }
    }

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Call handleResize initially to handle the initial screen size
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingsOpen]); // Dependency on settingsOpen ensures the effect runs when settingsOpen changes
  useEffect(() => {
    getTheme()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (navRef.current) {
      navRef.current.style.backgroundColor = color
    }
  }, [color, themeData])


  const onCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas({ width: 1400, height: 520 });

      // Convert to Blob (asynchronous)
      croppedCanvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], "cropped-image.webp", { type: "image/webp" });
          setCroppedPicFile(file); // Save File
        }
      }, "image/webp", 0.6);

      // Convert to Base64 (synchronous)
      setCroppedPic(croppedCanvas.toDataURL());
    }
  };

  useEffect(() => {
    if (coverPic === null) {
      setButtonView(false)
    }
  }, [coverPic])

  return (
    <>
      {cropedOpen && <div onClick={toggleCropedOpen} className="fixed z-[99999] top-0 left-0 w-full h-full bg-black bg-opacity-50 px-5  flex flex-col items-center justify-center">
        <div onClick={(e) => e.stopPropagation()} className="flex flex-col relative gap-5 items-center md:w-[60%] w-full  rounded-md bg-white px-4 py-8">
          {coverPic && (
            <Cropper
              src={coverPic || ""}
              style={{ height: 500, width: "100%" }}
              aspectRatio={1400 / 520} // Fixed aspect ratio (1400x520)
              viewMode={1} // Restricts cropping to image bounds
              zoomable={true} // Allows zooming
              scalable={false} // Prevents scaling
              cropBoxResizable={false} // Prevents resizing
              cropBoxMovable={true} // Allows dragging the crop box
              autoCropArea={1} // Ensures full image is visible initially
              ref={cropperRef}
            />
          )}
          <div className="text-center">{t("themes.bestResolution")}</div>
          <div className="flex gap-5 items-center justify-center">
            <button onClick={() => {
              onCrop()
              toggleCropedOpen()
            }} className="px-5 py-2 mt-2 rounded-md bg-sidebar text-base font-medium text-skyblue">{t("themes.save")}</button>
            <button type="button" className="mt-2 rounded-md bg-error px-5 py-2 text-base font-medium text-white" onClick={() => {
              setCoverPic(beforeCrop)
              toggleCropedOpen()
              if (coverPic === beforeCrop) {
                setButtonView(false)
              }
            }}>
              {t("themes.close")}
            </button>
          </div>
        </div>

      </div>}
      {loading && !themeData && !categories && !coverPic ? <>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-5">
          <Skeleton className="w-full h-[100vh] dark:bg-slate-600 dark:bg-opacity-35  rounded-lg hidden col-span-1 md:block" />
          <Skeleton className="w-full h-[100vh] dark:bg-slate-600 dark:bg-opacity-35  rounded-lg col-span-4" />
        </div>

      </> : <>
        <section className="xl:flex gap-2 ">

          <div className="relative xl:w-fit  felx w-full h-full ">
            <div
              className="cursor-pointer p-5 xl:hidden"
              onClick={openSettings}>
              <FaGear className="text-2xl " />
            </div>
            <div
              onClick={closeSettings}
              ref={layerRef}
              className="layer hidden bg-slate-800 fixed top-0 bg-opacity-50 left-0 w-full h-full z-10">

            </div>
            <div
              ref={settingsRef}
              className={` my-shadow bg-white -end-[500px] transition-all duration-200 top-0 bottom-0  p-5 w-[350px] h-full overflow-y-auto  xl:w-[350px] fixed   z-50 xl:flex xl:static  whitespace-nowrap border-e-2 flex-col  col-span-1`}>
              <div onClick={closeSettings} className="w-fit ms-auto text-red-600 text-xl cursor-pointer lg:hidden">
                <IoClose />
              </div>

              <div className="w-fit whitespace-normal">
                <h2 className="text-2xl font-bold mb-5">  {t("themes.title")}</h2>
                <p className="text-sm text-slate-600">{t("themes.description")}</p>
              </div>
              <div className="image-settings mt-10">
                <h1 className="text-xl font-semibold"> {t("themes.image")}</h1>
                <input onChange={e => {
                  const selectedFile = e.target.files?.[0];
                  if (selectedFile && selectedFile?.size > MAX_IMAGE_SIZE) {
                    toast.error(
                      t("themes.fileSizeExceeded", {
                        size: lang === "ar" ? MAX_IMAGE_SIZE_MB_String.ar : MAX_IMAGE_SIZE_MB_String.en
                      }) as string,
                    );
                    e.target.value = "";
                    return;
                  }
                  if (e.target.files && e.target.files.length > 0) {
                    setCoverPic(URL.createObjectURL(e.target.files[0]));
                    setCoverPicFile(e.target.files[0]);

                  }
                  setButtonView(true)
                  toggleCropedOpen()
                }} ref={coverRef} type="file" className="hidden" accept="image/*" />
                <div className="w-full relative h-fit my-5 border-dashed border-2 ">
                  {coverPic !== null ? <div
                    onClick={() => {
                      setCoverPic(null)
                      setCoverPicFile("")
                      setBeforeCrop(null)

                      if (coverRef.current) {
                        coverRef.current.value = ""; // Reset the file input
                      }
                    }}
                    className="absolute top-1 right-1 p-1 cursor-pointer bg-red-600 text-white text-xl rounded-full hover:bg-white hover:text-red-600 transition-colors duration-200">
                    <IoClose />
                  </div> : null}
                  {coverPic !== null ? <img src={croppedPic !== null ? croppedPic : coverPic || ""} alt="image" className="w-full h-fit object-cover" /> : <>
                    <div
                      onClick={() => {
                        coverRef.current?.click()
                      }}
                      className="flex flex-col items-center justify-center py-5 cursor-pointer ">
                      <CiImageOn className="text-[50px] text-slate-400" />
                      <p className="text-slate-400 text-sm flex flex-col gap-2">(jpg, jpeg, gif, png, webp) <span>{t("themes.bestResolution")} </span></p>
                    </div>
                  </>}

                </div>
              </div>
              {buttonView && <button onClick={() => {
                toggleCropedOpen()
              }} className="px-5 py-2 mt-2 rounded-md w-full bg-sidebar text-base font-medium text-skyblue">{t("themes.update")}</button>}
              <div className="color-settings flex flex-row  md:text-lg text-sm mt-5 items-center gap-2 justify-between ">
                <span className="font-semibold ">{t("themes.primaryColor")}</span>
                <div

                  className="flex items-center gap-2 text-[10px] border px-2 py-1 rounded-xl text-slate-500">
                  <input
                    ref={colorInputRef}
                    type="color"
                    value={color}
                    className="w-7 h-7 "
                    onChange={(e) => {
                      if (navRef.current) {
                        navRef.current.style.backgroundColor = e.target.value;
                        dispatch(setColor(e.target.value));

                      }
                    }} />
                  <FaChevronDown onClick={() => colorInputRef.current?.click()} />
                </div>
              </div>
              <div className="mt-10 flex flex-col gap-3">
                <h2 className="font-semibold ">{t("themes.categories")}</h2>
                <div className="mt-2 flex flex-col gap-3">
                  <DndContext sensors={sensors} onDragEnd={handleDragEnd} collisionDetection={closestCorners}

                  >
                    {categories && categories?.length > 0 ? <SortableContext items={categories.map(category => category.categoryID)} strategy={verticalListSortingStrategy}>
                      <MenuCards items={categories} />
                    </SortableContext> : <>

                      <div>
                        {t("themes.emptyCategories")}
                      </div>
                    </>}

                  </DndContext>
                </div>
              </div>

              <div>
                <button onClick={submitTheme} className="my-btn  mt-3 ">{t("themes.saveChanges")}</button>
              </div>
            </div>
          </div>

          <div className="col-span-3 flex-grow flex flex-col gap-5 ">
            <div className="view-settings xl:flex hidden my-shadow  bg-white  py-2 gap-3 p-2">
              <button
                onClick={() => {
                  containerRef.current?.classList.add("md:w-[465px]")
                  containerRef.current?.classList.add("mx-auto")
                  containerRef.current?.classList.remove("w-full")
                  cartRef1.current?.classList.add("opacity-0")
                  cartRef1.current?.classList.remove("md:flex")
                  cartRef2.current?.classList.add("flex")
                  cartRef2.current?.classList.remove("md:hidden")
                  cardContainerRef.current?.classList.remove("md:grid-cols-6")
                  setActiveButton("mobile")
                }}
                className={` w-fit border-2  p-2 text-xl rounded-full  hover:bg-sidebar hover:text-skyblue  transition-colors duration-200 ${activeButton == "mobile" ? "bg-sidebar text-skyblue" : "text-slate-500 bg-white"}`}>
                <CiMobile1 />
              </button>
              <button
                onClick={() => {
                  containerRef.current?.classList.add("w-full")
                  containerRef.current?.classList.remove("md:w-[465px]")
                  cartRef1.current?.classList.add("md:flex")
                  cartRef1.current?.classList.remove("opacity-0")
                  cartRef2.current?.classList.add("md:hidden")
                  cartRef2.current?.classList.remove("flex")
                  cardContainerRef.current?.classList.add("md:grid-cols-6")
                  setActiveButton("desktop")
                }}
                className={` w-fit border-2  p-2 text-xl rounded-full  hover:bg-sidebar hover:text-skyblue  transition-colors duration-200 ${activeButton == "desktop" ? "bg-sidebar text-skyblue" : "text-slate-500 bg-white"}`}>
                <CiLaptop />
              </button>
            </div>
            <div
              ref={containerRef}
              className="menu-preview my-shadow transition-all duration-500 w-full h-fit items-center  bg-[#FBFBFB]  overflow-hidden ">

              <nav ref={navRef} className=" p-3 flex justify-center items-center gap-5">
                <div className="w-[80%] relative">
                  <div className="bg-white w-full h-12 rounded-md"></div>
                  <div className="flex items-center absolute top-1 gap-2 right-1">
                    <span className=" text-sm text-center w-fit text-green-800 flex flex-col">{t("themes.receiveFrom")}< span className="text-black">
                      {t("themes.branchName")}</span></span>
                    <FaBagShopping />
                  </div>
                </div>
                <MdMenu className="  bg-white w-8 h-8 rounded-lg p-1" />
              </nav>
              <div className="main-pic  w-full my-2   flex justify-center items-center">
                <img src={themeData?.logo} alt="" className="w-44" />
              </div>
              {coverPic !== null ? <div className="hero-pic w-full max-h-[400px] px-5 mx-auto rounded-md overflow-hidden">
                <img src={croppedPic !== null ? croppedPic : coverPic || ""} alt="" className="w-full h-full " />
              </div> : null}
              <div ref={cardContainerRef} className="md:grid md:grid-cols-6 flex flex-col-reverse relative gap-4 p-2">
                <div className="col-span-5  flex flex-col gap-3 " >
                  {themeData && themeData?.categories.length > 0 ? themeData?.categories.map((e: Category) =>
                    <Category key={e.categoryID} items={e} />

                  ) : <>
                    <div className="text-center font-bold text-sidebar">
                      {t("themes.emptyMenu")}
                    </div>
                  </>}
                </div>
                <div
                  ref={cartRef1}
                  className="col-span-1 xl:flex   w-fit  text-center hidden  justify-center items-center flex-col gap-2 border sticky top-5   h-fit px-1 py-5 mt-16  rounded-md ">
                  <IoCart className="text-[40px]  text-slate-500 mx-auto" />
                  <p>   {t("themes.addProductFromList")}</p>
                </div>
              </div>
              <div
                ref={cartRef2}
                className=" text-center  justify-center items-center flex-col mb-2 flex xl:hidden gap-2 border w-fit  mx-auto  h-fit px-5 py-5 mt-10  rounded-md ">
                <IoCart className="text-[40px] mx-auto text-slate-500" />
                <p>{t("themes.addProductFromList")}</p>
              </div>
              <footer className="bg-black text-white flex justify-around  py-5 items-center">
                <div className="logo w-[100px]">
                  <img src={themeData?.logo} alt="" />
                </div>
                <div className="flex items-center gap-10">
                  <div className="socials flex flex-col items-center gap-2">
                    <span>{t("themes.contactUs")}</span>
                    <div className="flex items-center gap-2 text-white   text-[25px]">
                      <FaWhatsapp />
                      <LuPhone />
                    </div>
                  </div>
                  <div className="socials flex flex-col items-center gap-2">
                    <span>{t("themes.followUs")}</span>
                    <div className="flex items-center gap-2 text-white   text-[25px]">
                      <FaSnapchat />
                      <FaInstagram />
                      <LuFacebook />
                      <LuLinkedin />
                      <PiTiktokLogo />
                      <FaXTwitter />
                    </div>
                  </div>
                </div>

              </footer>
            </div>
          </div>
        </section ></>}
    </>
  )
}

export default Theme
